import React, { Component } from 'react';
import { Title } from '../Components';
import { OptionType } from './Options';
// import Fade from 'react-reveal/Fade';


class StepType extends Component {
	constructor() {
		super();
	}

	render() {
		const { selectedQuantityOption, options, handleTypeSelection } = this.props
		const title = `Pick ${selectedQuantityOption.quantity} Pair${selectedQuantityOption.quantity > 1 ? 's' : ''}`
		return (
			<div>
				{/* <Fade big delay={400}> */}
					<Title title={title} />
				{/* </Fade> */}
				{/* <Fade big delay={500}> */}
					{options &&
						<div className="BoxBuilder_Options BoxBuilder_Options--Type">
							{options.map((option, index) => <OptionType
								{...option}
								setCurrency={this.props.setCurrency}
								handleTypeSelection={handleTypeSelection}
								key={`type-option-${index}`}
							/>)}
						</div>
					}
				{/* </Fade> */}
			</div>
		)
	}
}

export default StepType;